import { Provider, inject, observer } from 'mobx-react';

import HeaderControl from './controls/header-control';
import LoadingSlider from 'bz-core-controls/controls/layout/loading-slider';
import React from 'react';
import Report from 'bz-core-controls/controls/general/report';
import { Show } from 'bz-core-controls';
import ViewStore from './stores/view-store';
import { computed } from 'mobx';

import './style.styl';

@inject('clinicalStore')
@observer
class CaseReport extends React.Component {
  static defaultProps = {
    viewable: false,
    onEdit: () => {}
  };

  constructor(props) {
    super(props);
    let { store, clinicalStore } = props;
    this.vm = new ViewStore(store, clinicalStore.prontoStore);
    this.vm.open = !!props.viewable;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.viewable) this.vm.open = true;
  }

  render() {
    if (!this.show) {
      return null;
    }

    let { vm, className } = this;
    let { navKey, onEdit } = this.props;

    return (
      <Provider vm={vm}>
        <div id={navKey} className={className}>
          <HeaderControl navKey={navKey} onEdit={onEdit} />
          <LoadingSlider loading={vm.loading}>
            <Show if={this.open}>
              <div className="clinical-page-content">
                <ErrorMessage />
                <ReportWrapper />
              </div>
            </Show>
          </LoadingSlider>
        </div>
      </Provider>
    );
  }

  @computed
  get show() {
    let { referralStore } = this.props.clinicalStore.caseStore;

    const canReportToPronto = !!referralStore && referralStore.referral.canReport;
    return !!canReportToPronto;
  }

  @computed
  get open() {
    let { navKey, clinicalStore } = this.props;
    let { status } = clinicalStore.prontoStore;
    let { open, report, loading } = this.vm;
    if (!!loading || status !== 'fullfilled' || !report || report.status === 3) return false;
    return open || clinicalStore.activePageKeys.indexOf(navKey) > -1;
  }

  @computed
  get className() {
    let css = ['clinical-page', 'pronto-report'];
    css.push(this.open ? 'open' : '');
    return css.join(' ');
  }
}

@inject('vm')
@observer
class ErrorMessage extends React.Component {
  render() {
    if (!this.show) return null;

    let { message } = this.props.vm.report;

    return <div className="error-message">{message}</div>;
  }

  @computed
  get show() {
    let { message } = this.props.vm.report;
    return !!message && !!message.trim();
  }
}

@inject('vm')
@observer
class ReportWrapper extends React.Component {
  render() {
    return !!this.exists ? <Report store={this.props.vm.report.draft} /> : null;
  }

  @computed
  get exists() {
    return !!this.props.vm.report;
  }
}

export default CaseReport;
